import "angular-translate";
import "./assets/TranslationLanguages.scss";
import TranslationsConfig from "./config/TranslationsConfig";
import TranslationsInit from "./config/TranslationsInit";
import {LanguageService} from "./service/LanguageService";

import Components from "./components";
import Pipes from "./pipes";

const ModuleName = "tfApp.translation";

export default angular.module(ModuleName, ["pascalprecht.translate", Components(ModuleName), Pipes(ModuleName)])
                      .service(LanguageService.id, LanguageService)
                      .config(TranslationsConfig)
                      .run(TranslationsInit)
                      .name;
